import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Col, Form, Row, Spin } from 'antd';
import { AdminUserRequest } from '../../../../request/AuthRequest';
import { useState } from 'react';
import useStore from '../../../../store';

const FormComponent = observer((props) => {
	const { handleChange, onFinish, id, form } = props;
	const [roleLoading, setRoleLoading] = useState(true);
	const {
		ADMINUSER: { getRoleList, roleList, adminUserDetail },
	} = useStore();

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={12}>
					<InputComponent
						required
						name="firstName"
						label="First Name"
						placeholder="Enter First Name"
						onChange={handleChange}
						rules={AdminUserRequest.firstName}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="lastName"
						label="Last Name"
						placeholder="Enter Last Name"
						onChange={handleChange}
						rules={AdminUserRequest.lastName}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="email"
						label="Email"
						placeholder="Enter Email Address"
						onChange={handleChange}
						rules={AdminUserRequest.email}
						disabled={id === 'EditForm' ? true : false}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="mobileNo"
						label="Mobile No."
						placeholder="Enter Mobile No."
						onChange={handleChange}
						rules={AdminUserRequest.mobileNo}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="userName"
						label="User Name"
						placeholder="Enter User Name"
						onChange={handleChange}
						rules={AdminUserRequest.userName}
						disabled={id === 'EditForm' ? true : false}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						type="select"
						showSearch={false}
						name="eAdminRoleId"
						label="Select Role"
						placeholder="Select Role"
						onFocus={() =>
							roleLoading &&
							getRoleList().then(() => setRoleLoading(false))
						}
						notFoundContent={
							roleLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values: roleList || [
								{
									eAdminRoleId:
										adminUserDetail &&
										adminUserDetail.eAdminRoleId &&
										adminUserDetail.eAdminRoleId,
									adminRoleName:
										adminUserDetail &&
										adminUserDetail.adminRoleName &&
										adminUserDetail.adminRoleName,
								},
							],
							value_key: 'eAdminRoleId',
							text_key: 'adminRoleName',
						}}
						onChange={handleChange}
						rules={AdminUserRequest.role}
					/>
				</Col>
				{id !== 'EditForm' && (
					<>
						<Col span={12}>
							<InputComponent
								type="password"
								name="password"
								label="Password"
								placeholder="xxxxxxx"
								rules={AdminUserRequest.password}
								onChange={handleChange}
							/>
						</Col>
						<Col span={12}>
							<InputComponent
								type="password"
								name="cn_password"
								label="Confirm Password"
								placeholder="xxxxxxx"
								rules={AdminUserRequest.cn_password}
								onChange={handleChange}
							/>
						</Col>
					</>
				)}
			</Row>
		</Form>
	);
});

export default FormComponent;
